import { render, staticRenderFns } from "./TabDO.vue?vue&type=template&id=145fda64&"
import script from "./TabDO.vue?vue&type=script&lang=js&"
export * from "./TabDO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports